export default "__VITE_ASSET__CdxBWMF2__"